import React, { Fragment, useEffect, useState } from "react";
import { useRouter } from "next/router";
import Header from "../../components/_App/Navbar1";
import StickyFoot from "../../components/globals/StickyFoot";
import * as fbq from "../../lib/fpixel";
import * as gtag from "../../lib/gtag";
import VideoBox from "../../components/products/video-box";
import DoubleHeading from "../../components/products/double-heading";
import ProductCover from "../../components/globals/product-cover";
import Reviews from "../../components/products/reviews";
import RelatedProducts from "../../components/products/related-products";
import SampleHover from "../../components/products/sample-hover";
import Features from "../../components/products/features";
import Head from "next/head";
import TestimonialSlider from "../../components/products/testimonial-slider";
import Descripton from "../../components/products/text-box";
import ImageSlider from "../../components/products/image-slider";
import ProductBreadNav from "../../components/products/product-bread-nav";
import ProductBrief from "../../components/products/product-brief";
import orderAPI from "../../axios-setup/order-service";
import { convertToImageKit } from "../../utils/convert-to-imagekit";
import Modal from "../../components/products/Modal";
import Footer from "../../components/_App/Footer";
import dayjs from "dayjs";
import ReactGA from "react-ga";
import webAPI from "../../axios-setup/web-api";
import VisibilitySensor from "react-visibility-sensor";
import FAQ from "../../components/products/faq";

import { content } from "../../utils/content/product";
// import { LCPDivisons } from "../../utils/lcp";

export default function CourseDetails({ product, dataNav, product_link }) {
  useEffect(() => {
    ReactGA.event({
      category: "Product Page",
      action: "product_view",
      label: "Product",
      nonInteraction: true,
    });
  }, []);
  let { data } = product;

  const router = useRouter();

  // useEffect(() => {
  //   console.log("Generating LCP Sub Divisons new");
  //   LCPDivisons();
  // }, []);

  const [reviewEvent, setReviewEvent] = useState(false);
  const [showSampleHover, setShowSampleHover] = useState(false);

  const logCtr = async () => {
    const hash_key = router.query.referral_code;
    if (typeof window !== "undefined") {
      try {
        // console.log({
        //   hash_key,
        //   browser_id: localStorage.getItem("FPJS").replace(/"/g, ""),
        //   landing_url: window.location.href,
        // });
        const res = await orderAPI.post("/url/log", {
          hash_key,
          browser_id: localStorage.getItem("FPJS").replace(/"/g, ""),
          landing_url: window.location.href,
        });
        // console.log(res.data, "hheheheniduidsfuidsfuisbfdsunbfdsinbfnbdsib ");
      } catch (error) {
        console.log(error);
      }
    }
  };

  useEffect(() => {
    if (
      router.query.referral_code &&
      router.query.referral_code !== "" &&
      typeof window !== "undefined"
    ) {
      logCtr();
    }
  }, [router]);

  useEffect(() => {
    if (typeof window !== "undefined") {
      localStorage.setItem("init_checkout", "false");
    }
  }, [product]);

  useEffect(() => {
    fbq.event("ViewContent", {
      content_ids: [data.sku || createSkuFromName(data.name)],
      content_type: "product",
      content_name: data.name,
      value: data.offer_price,
      currency: "INR",
    });
    // const webEngageLog = () => {
    //   // console.log("Tracking product viewed event for - ", product);
    //   console.log("infunc", localStorage.getItem("FPJS"));
    //   if (localStorage.getItem("FPJS")) {
    //     window.webengage.track("Product Page Viewed", {
    //       // "product_id": product.id,
    //       "Product Name": data.name,
    //       "Product Slug": data.product_link,
    //       "Product URL": router.pathname,
    //       "FPJS ID": localStorage.getItem("FPJS").replace(/"/g, ""),
    //       Subdomain: "web.toppersnotes.com",
    //     });
    //   }
    // };
    // webEngageLog();
    // window.addEventListener("storage", webEngageLog);

    // return () => {
    //   window.removeEventListener("storage", webEngageLog);
    // };
  }, []);

  useEffect(() => {
    gtag.customPageView(
      data.sku || createSkuFromName(data.name),
      "product",
      data.offer_price
    );
  }, []);

  const createSkuFromName = (name) => {
    // console.log("Sku Name", name.replace(/\s/g, "").toLowerCase().slice(0, 10));
    // console.log("createSkuFromName:", name);
    return name && name.replace(/\s/g, "").toLowerCase().slice(0, 10);
  };

  const [showModal, setShowModal] = React.useState(false);

  useEffect(() => {
    setTimeout(() => {
      //check from db
      if (data.leadModalOpen == "1") {
        setShowModal(true);
        // let diff1;

        // const current_date1 = dayjs(new Date());
        // //100 will always give true
        // diff1 = localStorage.getItem("LEAD_MODAL_DISMISSED_ON")
        //   ? current_date1.diff(
        //       dayjs(localStorage.getItem("LEAD_MODAL_DISMISSED_ON")),
        //       "day",
        //       false
        //     )
        //   : 100;

        // //check if it is dismissed or not
        // if (diff1 > 1) {
        //   let diff2 = 0;

        //   const current_date2 = dayjs(new Date());
        //   diff2 = localStorage.getItem("LEAD_MODAL_SUBMITTED_ON")
        //     ? current_date2.diff(
        //         dayjs(localStorage.getItem("LEAD_MODAL_SUBMITTED_ON")),
        //         "day",
        //         false
        //       )
        //     : 100;
        //   const examIdInLocalStorage = localStorage.getItem(
        //     "LEAD_MODAL_EXAM_ID"
        //   )
        //     ? localStorage.getItem("LEAD_MODAL_EXAM_ID")
        //     : -1;
        //   //check for the same lead for next 7 days

        //   if (examIdInLocalStorage != data.exam_id) {
        //     setShowModal(true);
        //   } else {
        //     if (diff2 > 7) {
        //       setShowModal(true);
        //     }
        //   }
        // }
      }
    }, 5000);
  }, []);

  const [scrollY, setScrollY] = useState(0);

  useEffect(() => {
    const handleScroll = () => {
      setScrollY(window.scrollY);
      if(window.scrollY > 600) {
        setShowSampleHover(true); // Set the visibility to true if scrollY exceeds 300
        }
    };

    // just trigger this so that the initial state
    // is updated as soon as the component is mounted
    // related: https://stackoverflow.com/a/63408216
    handleScroll();

    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="relative bg-white overflow-hidden">
      {showModal && (
        <Modal
          productExamId={data.exam_id}
          lang={data.lang}
          page="product"
          showModal={showModal}
          setShowModal={setShowModal}
        />
      )}

      <Head>
        {/* <link
          rel="dns-prefetch"
          href="https://toppersnotes-web.s3.ap-south-1.amazonaws.com"
        ></link>
        <link rel="dns-prefetch" href="https://api.toppersnotes.com"></link>
        <link
          rel="dns-prefetch"
          href="https://inz311c480d.in.webengage.co"
        ></link> */}
        {data &&
          data.assets &&
          data.assets.length > 0 &&
          data.assets[0].type == "image" && (
            <link
              rel="preload"
              as="image"
              imagesrcset={convertToImageKit(data.assets[0].url)}
            ></link>
          )}
      </Head>

      <Header data={dataNav} />
      <div className="relative sm:pb-14 pb:16">
        <div className="grid bg-white border-btm grid-cols-6 gap-8 p-6 md:w-10/12 mx-auto">
          <div className="col-span-6 md:col-span-3">
            <ImageSlider slug={product_link} product={data} />
          </div>

          <div className="col-span-6 md:col-span-3">
            <ProductBreadNav product={data} />
            <ProductBrief lang={data.lang} product={data} />
          </div>
        </div>
        {data.Testimonials && data.Testimonials.length > 0 && (
          <TestimonialSlider
            lang={data.lang}
            testimonials={data.Testimonials}
            showHeading={true}
            productName={data.name}
          />
        )}
        <VideoBox toppersChoice={data.ToppersChoices} product={data} />
        <div className="w-full md:w-4/5 mx-auto">
          <Features
            features={data.features}
            product_link={data.product_link}
            feature_title={data.feature_title}
          />
        </div>

        {data && data.samples && data.samples.length > 6 ? (
          <Fragment>
            <DoubleHeading text={content["descriptionHeading"][data.lang]} />
            <div className="w-full md:w-4/5 mx-auto">
              <Descripton
                description={data.description}
                product_link={data.product_link}
              />
            </div>
            {data.samples && data.samples.length > 0 && (
              <DoubleHeading text={content["sampleHeading"][data.lang]} />
            )}

            <ProductCover
              productName={data.name}
              productSamples={data.samples}
            />
          </Fragment>
        ) : (
          <Fragment>
            {data.samples && data.samples.length > 0 && (
              <DoubleHeading text={content["sampleHeading"][data.lang]} />
            )}

            <ProductCover
              productName={data.name}
              productSamples={data.samples}
            />
            <DoubleHeading text={content["descriptionHeading"][data.lang]} />
            <div className="w-full md:w-4/5 mx-auto">
              <Descripton
                description={data.description}
                product_link={data.product_link}
              />
            </div>
          </Fragment>
        )}
        <VisibilitySensor
          partialVisibility={true}
          resizeCheck={true}
          scrollCheck={true}
          onChange={(isVisible) => {
            if (!reviewEvent && isVisible) {
              ReactGA.event({
                category: "reviews seen",
                action: "reviews_seen",
                label: data.name,
                nonInteraction: true,
              });
              setReviewEvent(true);
            }
          }}
        >
          <div>
            <Reviews lang={data.lang} reviews={data.reviews} product={data} />
          </div>
        </VisibilitySensor>

        {/* {data && data.samples && data.samples.length > 0 && showSampleHover && (
            <SampleHover data={data} />
        )} */}

        <RelatedProducts relatedProduct={data.relatedProducts} product={data} />
        {data.faq && <FAQ lang={data.lang} faqs={JSON.parse(data.faq)} />}
      </div>
      <StickyFoot scroll={scrollY} product={data} />
      <Footer />
    </div>
  );
}

export const getStaticPaths = async () => {
  const res = await webAPI.get(`/products/productswithslug`);
  const products = res.data;
  const paths = products.data.rows.map((product) => ({
    params: { product_link: product.product_link.toString() },
  }));

  return {
    paths,
    fallback: "blocking",
  };
};

export const getStaticProps = async (context) => {
  const product_link = context.params.product_link;

  const res = await webAPI.get(`/product?slug=${product_link}`);
  const product = res.data;
  return {
    props: { product, product_link },
    revalidate: 3600,
  };
};
